import Model from "./Model";
import UserDiscipline from "./UserDiscipline";

const NEEDS = ['Yes', 'No', 'Unsure','Yes']

export default class ProjectPhase extends Model
{
    static Key = 'ProjectPhase';

    static normalize(props) {
        let scope = {...props}
        let percent_markup = props.percent_markup || 0;
        let deliverables = [...(scope.deliverables || [])];

        deliverables = TB.orderBy(deliverables, ['display_index', d => !!d.display_index], ['asc', 'desc']);

        scope.deliverables = TB.map(deliverables, (deliverable, delIndex) => {

            let phase_index = scope.display_index;
            let display_index = delIndex + 1;
            let activities = [...(deliverable.activities || [{
                name: `Activity for ${deliverable.name}`,
                is_active: true
            }])]
            activities = TB.orderBy(activities, ['display_index', d => !!d.display_index], ['asc', 'desc']);

            activities = TB.map(activities, (activity, aIndex) => {
                let activity_index = aIndex + 1;
                let deliverable_index = display_index;

                let disciplines = activity.disciplines || deliverable.disciplines || [];
                disciplines = TB.orderBy(disciplines, ['display_index', d => !!d.display_index], ['asc', 'desc']);

                disciplines = TB.map(disciplines, (discipline, dIndex) => {
                    let deliverable_index = display_index;

                    let market_rate = UserDiscipline.rateForDiscipline(discipline.id, percent_markup,true)
                    let estimated_cost = 0;
                    if (market_rate) {
                        estimated_cost = Math.ceil(market_rate) * discipline.total_hours
                    }

                    let talent_opp = discipline.talent_opp;

                    return {...discipline, talent_opp, estimated_cost, market_rate, activity_index, deliverable_index, phase_index, display_index: dIndex + 1};
                });

                let activeDisciplines = TB.filter(disciplines, ['is_active', true])
                let total_hours = TB.sumBy(activeDisciplines, 'total_hours');
                let estimated_cost = TB.sumBy(activeDisciplines, 'estimated_cost');

                return {...activity, disciplines, estimated_cost, total_hours, display_index: activity_index, deliverable_index, phase_index};
            });

            let total_hours = TB.sumBy(activities,'total_hours');
            let estimated_cost = TB.sumBy(activities,'estimated_cost');

            return {...deliverable, activities, estimated_cost, display_index, phase_index, total_hours}
        })
        return scope;
    }


    updateDeliverable(props = {}) {
        let deliverables = TB.map(this.deliverables, del => {
            if (del.display_index === props.display_index) {
                for (let [key, value] in Object.entries(props)) {
                    del[key] = value;
                }
            }
            return del;
        });

        return ProjectPhase.make({...this, deliverables})
    }

    updateDiscipline(props = {}) {
        let deliverable = TB.find([...this.deliverables], ['display_index', props.deliverable_index]);
        if (!deliverable) return this;

        deliverable.disciplines = TB.map(deliverable.disciplines, dis => {
            if (dis.display_index === props.display_index) {
                for (let [key, value] in Object.entries(props)) {
                    dis[key] = value;
                }
            }
            return dis;
        });

        return this.updateDeliverable(deliverable)
    }
}